import { arrayOf, object } from 'prop-types';
import { Box } from '@material-ui/core';
import TourFab from './TourFab';
import Tour from './Tour';
import useTours from './useTours';

/**
 * Punto de entrada de los tours de una pantalla: botón flotante, menú y
 * overlay en un solo componente. Instrumentar una pantalla nueva es agregar
 * `data-tour="..."` a lo que se quiera explicar y poner:
 *
 *   <TourLauncher tours={MIS_TOURS} />
 */
function TourLauncher({ tours }) {
  const state = useTours(tours);

  return (
    <Box>
      <TourFab tours={tours} onStart={state.start} />
      <Tour {...state} />
    </Box>
  );
}

TourLauncher.defaultProps = {
  tours: [],
};

TourLauncher.propTypes = {
  tours: arrayOf(object),
};

export default TourLauncher;
